const actionTypes = {
  LOAD_POLLING_STATIONS: 'LOAD_POLLING_STATIONS',
  LOAD_WHITELIST: 'LOAD_WHITELIST',
  LOAD_RESULTS: 'LOAD_RESULTS',
  LOAD_DETACHED: 'LOAD_DETACHED',
};

export default actionTypes;
